import React, { useEffect, useRef, useState } from 'react'
import { BiLeftArrow, BiRightArrow } from 'react-icons/bi';
import { svgs } from '../assets/svgs';

export const SpeakerModal = ({ speakers, speakerIdx, handleClose }) => {
   const [modalInfo, setModalInfo] = useState({});
   const [modalIdx, setModalIdx] = useState({});
   const [showIndustries, setShowIndustries] = useState(false);
   const [arrowsStyle, setArrowsStyle] = useState({ left: { opacity: 0.75 }, right: { opacity: 0.75 } })
   const modalRef = useRef(null);
   const infoRef = useRef(null);

   useEffect(() => {
      modalRef.current.focus()
      setModalIdx(speakerIdx)
      setModalInfo(data(speakerIdx));
   }, [])// eslint-disable-line 

   const data = (idx) => {
      return {
         image: speakers[idx]?.headshot_url,
         name: speakers[idx]?.firstname + " " + speakers[idx]?.lastname,
         job: speakers[idx]?.jobtitle,
         company: speakers[idx]?.company,
         bio: speakers[idx]?.bio,
         website: speakers[idx]?.website,
         linkedin: speakers[idx]?.linkedin_uid,
         industries: speakers[idx]?.industries?.split(";")
      }
   }
   const arrowsControl = (dir) => {

      switch (dir) {
         case 'left':
            setArrowsStyle({ ...arrowsStyle, left: { opacity: 1, fontSize: '2.55em' } })
            setTimeout(() => setArrowsStyle({ ...arrowsStyle, left: { opacity: 0.75, fontSize: '2.5em' } }), 100)
            break;
         case 'right':
            setArrowsStyle({ ...arrowsStyle, right: { opacity: 1, fontSize: '2.55em' } })
            setTimeout(() => setArrowsStyle({ ...arrowsStyle, right: { opacity: 0.75, fontSize: '2.5em' } }), 100)
            break;
         default:
            break;
      }
   }
   // events
   const handelArrowClick = (e, diff) => {
      e.stopPropagation()
      if ((modalIdx === 0 && diff === -1) || (modalIdx === speakers.length - 1 && diff === 1)) {
         return
      }
      infoRef.current.scrollTo(0, 0)
      setModalInfo(data(modalIdx + diff));
      setModalIdx(prev => prev + diff)
      arrowsControl(diff === 1 ? 'right' : 'left')
   }
   const handleKeyDown = (e) => {
      switch (e.key) {
         case 'ArrowLeft':
            if (modalIdx === 0) return
            handelArrowClick(e, -1);
            arrowsControl('left')
            break;
         case 'ArrowRight':
            if (modalIdx === speakers.length - 1) return
            handelArrowClick(e, 1);
            arrowsControl('right')
            break;
         default:
            break;
      }
   };
   if (!modalInfo) return <></>
   return (
      <div tabIndex="0" onKeyDown={handleKeyDown} ref={modalRef} className='speaker-modal'>
         <section>
            <img src={modalInfo.image} alt='head-shot' />
            <h6>{modalInfo.name}</h6>
            <h5>{modalInfo.job}</h5>
            <h4>{modalInfo.company}</h4>
         </section>

         {speakers.length > 1 && <BiLeftArrow style={arrowsStyle.left} className='arrow-left' onClick={(e) => handelArrowClick(e, -1)} />}
         {speakers.length > 1 && <BiRightArrow style={arrowsStyle.right} className='arrow-right' onClick={(e) => handelArrowClick(e, 1)} />}

         <section>
            <div ref={infoRef} className='info'>
               {showIndustries
                  ? <div>
                     {modalInfo.industries?.map((industry, idx) =>
                        <span key={idx}>{industry}</span>
                     )}
                  </div>
                  : <p>{modalInfo.bio}</p>}
            </div>
            {modalInfo.industries && <button onClick={() => setShowIndustries(!showIndustries)}>{showIndustries ? 'Bio' : 'Industries'}</button>}
            <div className='btns'>
               <div className="web">
                  {
                     modalInfo.website &&
                     <a href={modalInfo.website} target='_blank' rel='noreferrer'>
                        {svgs.website}
                     </a>
                  }
                  {
                     modalInfo.linkedin &&
                     <a href={!modalInfo.linkedin.startsWith('http') ? `https://${modalInfo.linkedin}` : modalInfo.linkedin} target='_blank' rel='noreferrer'>
                        {svgs.linkedin}
                     </a>
                  }
               </div>
               <button className='btn' onClick={handleClose}>
                  close
               </button>
            </div>

         </section>
      </div >
   )
}